import {Inject, Injectable} from '@angular/core';
import {Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/empty';
import {ApiConfigService} from '../core/api-config.service';

@Injectable()
export class WrapperService {

	constructor(private http: Http, private apiConfig: ApiConfigService) {
	}

	public wrapGetRequest(url: string, methodName: string): Observable<any> {
		const fullUrl: string = this.buildUrl(url);
		console.log(`API GET Request: ${fullUrl}`);
		return this.http
			.get(fullUrl, { withCredentials: true })
			.map(this.extractData)
			.catch((response: Response) => this.handleError(response, methodName));
	}

	public wrapGetRequestWithParams(url: string, params: any,  methodName: string): Observable<any> {
		const fullUrl: string = this.buildUrl(url);
		console.log(`API GET Request with params: ${fullUrl}`, params);
		const queryParams: URLSearchParams = new URLSearchParams();
		Object.keys(params).forEach((key: string) => queryParams.set(key, params[key]));
		return this.http
			.get(fullUrl, {
				params: queryParams,
				withCredentials: true
			})
			.map(this.extractData)
			.catch((response: Response) => this.handleError(response, methodName));
	}

	public wrapPostRequest(url: string, data: any, methodName: string): Observable<any> {
		const fullUrl: string = this.buildUrl(url);
		console.log(`API POST Request: ${fullUrl}`, data);
		return this.http
			.post(fullUrl, data, { withCredentials: true })
			.map(this.extractData)
			.catch((response: Response) => this.handleError(response, methodName));
	}

	public wrapDeleteRequest(url: string, data: any, methodName: string): Observable<any> {
		const fullUrl: string = this.buildUrl(url);
		console.log(`API DELETE Request: ${fullUrl}`, data);
		return this.http
			.delete(fullUrl, { body: data, withCredentials: true })
			.map(this.extractData)
			.catch((response: Response) => this.handleError(response, methodName));
	}

	private buildUrl(url: string): string {
		// If URL already contains the full API URL, return as is
		if (url.startsWith('https://') || url.startsWith('http://')) {
			return url;
		}
		// Otherwise, build the full URL using the API configuration
		return this.apiConfig.getFullUrl(url);
	}

	private extractData(response: Response): any {
		return response.json() || {};
	}

	private handleError(response: Response, methodName: string): Observable<any> {
		console.error(`API Error in ${methodName}:`, response);
		console.error(`Status: ${response.status}, StatusText: ${response.statusText}`);

		if (response.status === 401) {
			console.log('Unauthorized - redirecting to login');
			window.location.href = '/login.html?expired=true';
			return Observable.of();
		}

		if (response.status === 0) {
			console.error('Network error - possible CORS issue or server unavailable');
			alert(`Network Error in ${methodName} method. Please check if the backend server is running and CORS is configured.`);
		} else {
			alert(`Technical Error in ${methodName} method. Status: ${response.status}`);
		}

		return Observable.throw(response);
	}

}



// WEBPACK FOOTER //
// ./src/app/api/wrapper.service.ts